/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamRevisionBotexamid200,
  GetApiV1ExamRevisionBotexamid400,
  GetApiV1ExamRevisionBotexamid401,
  GetApiV1ExamRevisionBotexamid404,
  GetApiV1ExamRevisionBotexamid500,
  GetApiV1ExamRevisionBotexamidPathParams,
  GetApiV1ExamRevisionBotexamidQueryParams,
  GetApiV1ExamRevisionBotexamidQueryResponse,
} from "../../types/examRevisionController/GetApiV1ExamRevisionBotexamid.ts";
import { classroomDisciplineBotExamReviewViewModelSchema } from "../classroomDisciplineBotExamReviewViewModelSchema.ts";

export const getApiV1ExamRevisionBotexamidPathParamsSchema = z.object({
  botExamId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1ExamRevisionBotexamidPathParams>;

export const getApiV1ExamRevisionBotexamidQueryParamsSchema = z.object({
  pageNumber: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(1),
}) as unknown as ToZod<GetApiV1ExamRevisionBotexamidQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamRevisionBotexamid200Schema = z.lazy(
  () => classroomDisciplineBotExamReviewViewModelSchema,
) as unknown as ToZod<GetApiV1ExamRevisionBotexamid200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1ExamRevisionBotexamid400Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionBotexamid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamRevisionBotexamid401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionBotexamid401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ExamRevisionBotexamid404Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionBotexamid404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamRevisionBotexamid500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamRevisionBotexamid500>;

export const getApiV1ExamRevisionBotexamidQueryResponseSchema = z.lazy(
  () => getApiV1ExamRevisionBotexamid200Schema,
) as unknown as ToZod<GetApiV1ExamRevisionBotexamidQueryResponse>;
